import { QueryClient } from '@tanstack/react-query'

function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5, // 5 minutes
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  })
}

function getQueryClient() {
  if (import.meta.hot) {
    if (!import.meta.hot.data.queryClient) {
      import.meta.hot.data.queryClient = createQueryClient()
    }
    return import.meta.hot.data.queryClient
  }
  return createQueryClient()
}

export const queryClient = getQueryClient()

